import MainEbook from "../components/ebook/MainEbook";

function Ebook() {
    return (
			<MainEbook/>
		);
}

export default Ebook;